import React from "react";
import styles from "../../../styles/Home.module.css";
import { Container, Row, Col } from "react-bootstrap";
import { Carousel } from "react-responsive-carousel";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Testimonial = () => {
  return (
    <Container className={styles.testimonialContainerParent}>
      <h1 className={styles.heading}>Client Testimonials</h1>
      <div className={styles.decoraion} style={{ width: "250px" }}></div>
      <div className={styles.testimonialContainer}>
        <Row>
          <Col md={12}>
            <Carousel>
              <div>
                <p className={styles.review}>
                  <span>
                    <i className="fas fa-quote-left"></i>
                  </span>
                  This App has helped a small company transition to a larger
                  more efficient company. All of our HR needs have been met with
                  WebHR and they are continuing to improve it. We started using
                  when we were 45 employees. Today we are over 235 employees and
                  our people management and real time tracking has been so
                  helpful as we make this transition.&quot;
                </p>
                <br />
                <p className={styles.reviewerName}>
                  - <span>Oliver G</span> - Tycoon Animation
                </p>
                <div>
                  <LazyLoadImage
                    src="https://cdn.webhr.co/images/Web/Reviews/Reviewer1.jpg"
                    className={styles.reviewerImg}
                    alt="testimonial"
                  />
                </div>
              </div>

              <div>
                <p className={styles.review}>
                  <span>
                    <i className="fas fa-quote-left"></i>
                  </span>
                  Excellent HR Software. Having all employee information at the
                  click of a button, all in one location has been essential to
                  streamlining daily processes.&quot;
                </p>
                <br />
                <p className={styles.reviewerName}>- Accalia B - Viva Belize</p>
                <div>
                  <LazyLoadImage
                    src="https://cdn.webhr.co/images/Web/Reviews/Reviewer2.jpg"
                    className={styles.reviewerImg}
                    alt="testimonial"
                  />
                </div>
              </div>

              <div>
                <p className={styles.review}>
                  <span>
                    <i className="fas fa-quote-left"></i>
                  </span>
                  Excellent team and support, customizable and great report
                  features. Scaleable, cost effective, feature rich and friendly
                  user interface. HR self service is first class. A great
                  marketing tool for HR department creating openness, easier
                  communication with employees and enabling employees to procure
                  HR services easily and fast.&quot;
                </p>
                <br />
                <p className={styles.reviewerName}>- Meiraj H - Almasaood</p>
                <div>
                  <LazyLoadImage
                    src="https://cdn.webhr.co/images/Web/Reviews/Reviewer3.jpg"
                    className={styles.reviewerImg}
                    alt="testimonial"
                  />
                </div>
              </div>

              <div>
                <p className={styles.review}>
                  <span>
                    <i className="fas fa-quote-left"></i>
                  </span>
                  Great timely statistics, extract options of data, automated
                  organization chart. Excellent support when the technical team
                  is involved.&quot;
                </p>
                <br />
                <p className={styles.reviewerName}>
                  - Suzy H - Human Resources at Centre for Humanitarian Dialogue
                </p>
                <div>
                  <LazyLoadImage
                    src="https://cdn.webhr.co/images/Web/Reviews/Reviewer4.jpg"
                    className={styles.reviewerImg}
                    alt="testimonial"
                  />
                </div>
              </div>

              <div>
                <p className={styles.review}>
                  <span>
                    <i className="fas fa-quote-left"></i>
                  </span>
                  This is the ANSWER you have been looking for! WebHR is THE
                  premier HR solution if your companies needs call for a
                  multitude of tasks that have to be accomplished daily.&quot;
                </p>
                <br />
                <p className={styles.reviewerName}>- Everett B - BFP</p>
                <div>
                  <LazyLoadImage
                    src="https://cdn.webhr.co/images/Web/Reviews/Reviewer5.jpg"
                    className={styles.reviewerImg}
                    alt="testimonial"
                  />
                </div>
              </div>

              <div>
                <p className={styles.review}>
                  <span>
                    <i className="fas fa-quote-left"></i>
                  </span>
                  It is easy to use and has on line tutorials for additional
                  support. The overall layout is attractive and not complicated
                  on the eyes. It is also well organized in the specific
                  areas.&quot;
                </p>
                <br />
                <p className={styles.reviewerName}>
                  - Nicola T - Twin Consulting & Training Services
                </p>
                <div>
                  <LazyLoadImage
                    src="https://cdn.webhr.co/images/Web/Reviews/Reviewer6.jpg"
                    className={styles.reviewerImg}
                    alt="testimonial"
                  />
                </div>
              </div>

              <div>
                <p className={styles.review}>
                  <span>
                    <i className="fas fa-quote-left"></i>
                  </span>
                  WebHR is great. WebHR is easy to use, has good customer
                  support and they are very responsive to our needs. They even
                  have been very flexible with making custom program
                  changes.&quot;
                </p>
                <br />
                <p className={styles.reviewerName}>
                  - Kevin M - Tucson Jewish Community Center
                </p>
                <div>
                  <LazyLoadImage
                    src="https://cdn.webhr.co/images/Web/Reviews/Reviewer2.jpg"
                    className={styles.reviewerImg}
                    alt="testimonial"
                  />
                </div>
              </div>
            </Carousel>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Testimonial;
